import { useAuth } from "../../hooks/useAuth";
import { Link } from "react-router-dom";
import { useI18n } from "../../i18n";
import IntroComponent from "../general/IntroComponent";
import CommonForm from "../general/CommonForm";
import { getPendingClaim } from "../../utils/pendingClaim";

const Register = () => {
  const auth = useAuth(); // tək instansiya — form da bunu istifadə edir
  const { t } = useI18n();
  const hasPendingCoupon = Boolean(getPendingClaim());

  return (
    <div className="w-full max-w-5xl bg-white rounded-3xl shadow-2xl overflow-hidden flex flex-col md:flex-row">
      {/* Sol sütun */}
      <IntroComponent
        title={hasPendingCoupon ? t("auth.pending_title") : t("auth.join_title")}
        description={
          hasPendingCoupon ? t("auth.pending_desc") : t("auth.join_desc")
        }
      />

      {/* Sağ sütun - Register Form */}
      <div className="md:w-1/2 p-8 sm:p-10">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 text-left">
          {t("auth.register_title")}
        </h2>

        {auth.errors.general && (
          <div className="mb-4 text-red-600 text-sm bg-red-50 border border-red-200 rounded-lg px-3 py-2">
            {auth.errors.general}
          </div>
        )}

        <CommonForm isLogin={false} auth={auth} />

        <p className="text-center text-gray-600 text-sm mt-4">
          {t("auth.have_account")}{" "}
          <Link
            to="/login"
            className="text-indigo-500 font-semibold hover:underline"
          >
            {t("auth.login_link")}
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
